import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4177faeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desc" }
const _hoisted_2 = { class: "desc" }
const _hoisted_3 = { class: "desc" }
const _hoisted_4 = { class: "cm-ui-mb5 cm-ui-mt20" }
const _hoisted_5 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    modelValue: _ctx.modalVisiable,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalVisiable) = $event)),
    title: _ctx.$t('groupClient.completeRegisterInfo'),
    "before-close": _ctx.closeModal,
    width: 550
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        onClick: _ctx.submitInfo,
        disabled: (_ctx.info.length === 0) || (_ctx.info.length > 30)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('groupClient.registerInfoModalSend')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_input, {
        class: "cm-ui-mb15",
        size: "small",
        placeholder: _ctx.$t('groupClient.registerInfoModalFormatTitle'),
        modelValue: _ctx.info,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.info) = $event)),
        onInput: _ctx.inputRules
      }, null, 8, ["placeholder", "modelValue", "onInput"]),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('groupClient.registerInfoModalValidDuration')), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('groupClient.registerInfoModalSendHintLine1')), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('groupClient.registerInfoModalSendHintLine2')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('groupClient.registerInfoModalPreviewTitle')), 1),
      _createElementVNode("img", {
        src: _ctx.registeInfoMessageDialogPic,
        width: "300",
        alt: _ctx.$t('groupClient.registerInfoModalPreviewAlt')
      }, null, 8, _hoisted_5)
    ]),
    _: 1
  }, 8, ["modelValue", "title", "before-close"]))
}